import MessageWithIcon from './MessageWithIcon.component';

export * from './MessageWithIcon.styled';

export default MessageWithIcon;
